if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        const handle = this.form.getAttribute('data-handle');
        const productType = this.form.getAttribute('data-productType');
        const templateSuffix = this.form.getAttribute('data-surffix');
        const sizeOptionEl = document.getElementById("option-size-custom");
        if (sizeOptionEl){
          const selectedValue = sizeOptionEl.value;
          if (selectedValue === "") {
            alert("Please select a size.");
            return;
          }else{
            document.querySelector('input[name="properties[Size]"]').value = selectedValue;
          }
        }
        const personalizationOptionEl = document.querySelector(".prd-Personalization_block.prd-Personalization-required input");
        if (personalizationOptionEl){
          const personalizationValue = personalizationOptionEl.value;
          if (personalizationValue === "") {
            alert("Please add Personalization.");
            return;
          }else{
            document.querySelector('input[name="properties[Personalization]"]').value = personalizationValue;
          }
        }

        let quantity = 1;
        let quantitystep = 1;
        if(document.querySelector('.quantity_selector-buy_buttons .quantity__input')) {
          quantity = document.querySelector('.quantity_selector-buy_buttons .quantity__input').value;
          quantitystep = document.querySelector('.quantity_selector-buy_buttons .quantity__input').getAttribute('step');
        }

        let giftName, giftRName, giftEmail, giftComment,giftRadioValue = false;
        if(document.querySelector('.gift-card-radio input[type="radio"]') != null){
           giftRadioValue = document.querySelector('.gift-card-radio input[type="radio"]:checked').value;
        }
        if (templateSuffix === 'gift-card' && giftRadioValue === 'true') {
          giftName = document.querySelector('input[name="properties[From]"]').value;
          giftRName = document.querySelector('input[name="properties[Recipient Name]"]').value;
          giftEmail = document.querySelector('input[name="properties[Recipient Email Address]"]').value;
          giftComment = document.querySelector('textarea[name="properties[Message]"]').value;
          
          const giftErrorEl = document.querySelector('.gift-card-field_error');
          let errorMessage = '';

          if (giftName === '' && giftEmail === '' && giftRName === '') {
            errorMessage = 'Email, sender name, and recipient name fields are required';
          } else if (giftName === '') {
            errorMessage = 'Sender name field is required';
          } else if (giftRName === '') {
            errorMessage = 'Recipient name field is required';
          } else if (giftEmail === '') {
            errorMessage = 'Email field is required';
          } else if (!this.isValidEmail(giftEmail)) {
            errorMessage = 'Invalid email format';
          }
          
          if (errorMessage) {
            giftErrorEl.querySelector('span').innerHTML = errorMessage;
            giftErrorEl.classList.remove('hd-Dnone');
            setTimeout(() => {
              giftErrorEl.classList.add('hd-Dnone');
            }, 6000);
            return;
          }
        }

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const metafield =this.form.querySelector('input[name="properties[_additional_services]"]');
          if(templateSuffix == 'gift-card' && giftRadioValue === 'true'){
            formData.append('properties[From]', giftName);
            formData.append('properties[Recipient Name]', giftRName);
            formData.append('properties[Recipient Email Address]', giftEmail);
            formData.append('properties[Message]', giftComment);
          }
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;
  
          fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              if(metafield != null && metafield.value != ''){
                this.matressProduct(metafield);
              }else{
                this.cart.renderContents(response);
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      // Function to validate email
      isValidEmail(email) {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(email);
      }

      async matressProduct (metafield){
        const id = metafield.value;
        const matressProductId = this.form.querySelector('[name=id]').value;
        const sectionId = this.form.querySelector('[name="section-id"]').value;
        const productId =this.form.querySelector('input[name="properties[_additional_services]"]').getAttribute('data-id');
        const metafieldformData = new FormData();
        metafieldformData.append('quantity', 1);
        metafieldformData.append('form_type', 'product');
        metafieldformData.append('utf8', '✓');
        metafieldformData.append('id', id);
        metafieldformData.append('properties[_matressProduct]', matressProductId);
        metafieldformData.append('product-id', productId);
        metafieldformData.append('section-id', sectionId);
        if (this.cart) {
          metafieldformData.append('sections',this.cart.getSectionsToRender().map((section) => section.id));
          metafieldformData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        const newconfig = fetchConfig('javascript');
        newconfig.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete newconfig.headers['Content-Type'];
        newconfig.body = metafieldformData;
        try {
          const data = await fetchJSON(`${routes.cart_add_url}.js`, newconfig)
          this.cart.renderContents(data);
        } catch (error) {
          console.error('Error processing the request:', error);
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
